import { Comic } from '@/mocks/comics';
import { Link } from 'react-router-dom';

interface ComicCardProps {
  comic: Comic;
  size?: 'small' | 'medium' | 'large';
}

export default function ComicCard({ comic, size = 'medium' }: ComicCardProps) {
  const sizeClasses = {
    small: 'w-[140px]',
    medium: 'w-[160px]',
    large: 'w-[180px]',
  };

  const imageHeight = {
    small: 'h-[190px]',
    medium: 'h-[220px]',
    large: 'h-[250px]',
  };

  return (
    <Link
      to={`/comic/${comic.id}`}
      className={`${sizeClasses[size]} group cursor-pointer shrink-0`}
    >
      {/* Cover */}
      <div
        className={`${imageHeight[size]} relative overflow-hidden rounded-lg mb-2`}
      >
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 韩漫在线免费阅读`}
          title={`${comic.title} - 韩漫网免费韩漫`}
          className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
        />
        {/* Status Badge */}
        <span
          className={`absolute top-2 left-2 px-2 py-0.5 rounded text-xs font-medium ${
            comic.status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-accent-500 text-background-50'
          }`}
        >
          {comic.status}
        </span>
        {/* Rating */}
        <div className="absolute bottom-2 right-2 flex items-center gap-1 bg-foreground-950/70 text-background-50 px-1.5 py-0.5 rounded text-xs">
          <div className="w-3 h-3 flex items-center justify-center">
            <i className="ri-star-fill text-[10px] text-primary-400"></i>
          </div>
          <span>{comic.rating}</span>
        </div>
      </div>

      {/* Info */}
      <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
        {comic.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-0.5 truncate">
        {comic.author}
      </p>
      {size !== 'small' && (
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-400">
            <i className="ri-eye-line text-[10px] mr-0.5"></i>
            {comic.views > 10000
              ? `${(comic.views / 10000).toFixed(0)}万`
              : comic.views}
          </span>
          <span className="text-xs text-foreground-400">
            共{comic.totalChapters}话
          </span>
        </div>
      )}
    </Link>
  );
}